import { render, staticRenderFns } from "./matrixtable.vue?vue&type=template&id=fa197e4a&"
import script from "./matrixtable.vue?vue&type=script&lang=ts&"
export * from "./matrixtable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa197e4a')) {
      api.createRecord('fa197e4a', component.options)
    } else {
      api.reload('fa197e4a', component.options)
    }
    module.hot.accept("./matrixtable.vue?vue&type=template&id=fa197e4a&", function () {
      api.rerender('fa197e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrixtable.vue"
export default component.exports